import { combineSlices } from "@reduxjs/toolkit";
import * as entities_dealer_index from "../../entities/dealer/index.js";
import * as entities_vehicle_index from "../../entities/vehicle/index.js";
import * as entities_vehicleEquipment_index from "../../entities/vehicleEquipment/index.js";
import * as features_benefitChoice_index from "../../features/benefitChoice/index.js";
import * as features_comparison_index from "../../features/comparison/index.js";
import * as features_credit_index from "../../features/credit/index.js";
import * as features_favorite_index from "../../features/favorite/index.js";
import * as features_filterChoice_index from "../../features/filterChoice/index.js";
import * as features_filterValues_index from "../../features/filterValues/index.js";
import * as features_tradeIn_index from "../../features/tradeIn/index.js";
import * as shared_store_config_index from "../../shared/store/config/index.js";
import * as shared_store_installation_index from "../../shared/store/installation/index.js";
import * as shared_store_marketingInfo_index from "../../shared/store/marketingInfo/index.js";
import * as shared_store_pagination_index from "../../shared/store/pagination/index.js";
import * as shared_store_reference_index from "../../shared/store/reference/index.js";
import * as widgets_equipments_index from "../../widgets/equipments/index.js";
import * as widgets_filterPanel_index from "../../widgets/filterPanel/index.js";
const rootReducer = combineSlices({});
export {
  features_benefitChoice_index as benefitChoice,
  features_comparison_index as comparison,
  shared_store_config_index as config,
  features_credit_index as credit,
  entities_dealer_index as dealer,
  widgets_equipments_index as equipments,
  features_favorite_index as favorite,
  features_filterChoice_index as filterChoice,
  widgets_filterPanel_index as filterPanel,
  features_filterValues_index as filterValues,
  shared_store_installation_index as installation,
  shared_store_marketingInfo_index as marketingInfo,
  shared_store_pagination_index as pagination,
  shared_store_reference_index as reference,
  rootReducer,
  features_tradeIn_index as tradeIn,
  entities_vehicle_index as vehicle,
  entities_vehicleEquipment_index as vehicleEquipment
};
